import { MonthlyInstallmentsOver12Months, ProposalStep3AnnualPayment, ProposalStep3PaymentOnCompletion, ProposalStep3ServiceAgreementTypeEnum, ProposalStep3StagedPayments, ProposalStep3UpfrontPayment } from "@gap/backend/app-services/proposal/models/ProposalStep3Dto"
import { ServiceRateTypeEnum } from "@gap/backend/app-services/services/models/ServiceRateTypesDto"
import { z } from "zod"

export const annualPaymentDefaults: z.output<typeof ProposalStep3AnnualPayment> = {
   annualPayment: true,
   annualPaymentDiscount: 5
}

export const paymentOnCompletionDefaults: z.output<typeof ProposalStep3PaymentOnCompletion> = {
   paymentOnCompletion: false
}

export const stagedPaymentsDefaults: z.output<typeof ProposalStep3StagedPayments> = {
   stagedPayments: true,
   stagedPaymentUpfront: 50,
   stagedPaymentMilestone: 0
}

export const upfrontPaymentDefaults: z.output<typeof ProposalStep3UpfrontPayment> = {
   upfrontPaymentInFull: true,
   upfrontPaymentInFullDiscount: 5
}

export const monthlyInstallmentsOver12MonthsDefaults: z.output<typeof MonthlyInstallmentsOver12Months> = {
   monthlyInstallmentsOver12Months: true
}

export const defaultRateType: ServiceRateTypeEnum = 'Per month'
export const defaultServicePrice = 0
export const defaultServiceUnits = 1
export const defaultServiceAgreementType: ProposalStep3ServiceAgreementTypeEnum = 'agreed'